export const waitForEl = (
  selector: string,
  timeoutMs = 2000,
): Promise<Element | null> => {
  if (typeof document === 'undefined') return Promise.resolve(null);

  const start = performance.now();

  return new Promise((resolve) => {
    const check = () => {
      const el = document.querySelector(selector);
      if (el) {
        resolve(el);
        return;
      }
      if (performance.now() - start >= timeoutMs) {
        resolve(null);
        return;
      }
      // Try again on next frame
      requestAnimationFrame(check);
    };
    check();
  });
};
